import Box from "@mui/material/Box";
import IconButton from "@mui/material/IconButton";
import CopyIcon from '@mui/icons-material/CopyAll';
import React from "react";
import DialogActions from "@mui/material/DialogActions";
import Button from "@mui/material/Button";
import List from "@mui/material/List";
import { Dialog, ListItem, ListItemButton, ListItemAvatar, Avatar, ListItemText, DialogContent, DialogContentText, DialogTitle } from "@mui/material";
import { blue } from "@mui/material/colors";

export interface AlertDialogProps {
    title: string
    message: string
    clientNames: string[]
    onCloneConfirm: (clientName: string) => void
}

export const CloneDialog: React.FC<AlertDialogProps> = (props: AlertDialogProps) => {
  const [open, setOpen] = React.useState(false);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const confirm = (clientName: string) => {
    props.onCloneConfirm(clientName)
    setOpen(false);
  }

  return (
    <Box
      sx={{
        borderRadius: 2,
        display: 'inline-block',
        backgroundColor: '#fafafa',
        margin: 2,
      }}
    >
      <IconButton aria-label="clone" onClick={handleClickOpen}>
          <CopyIcon />
      </IconButton>

      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          {props.title}
        </DialogTitle>
        
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            {props.message}
          </DialogContentText>
        </DialogContent>

        <List sx={{ pt: 0 }}>
          {props.clientNames.map((clientName) => (
            <ListItem disablePadding key={clientName}>
              <ListItemButton onClick={() => confirm(clientName)}>
                <ListItemText primary={clientName} />
              </ListItemButton>
            </ListItem>
          ))}
        </List>

        <DialogActions>
          <Button onClick={handleClose}>
            Cancel
          </Button>
        </DialogActions>
      </Dialog>

    </Box>
  )
}